import React from "react";
import Table from "../Table";
import PropTypes from "prop-types";
import { useFetchFixedRouteBusBlocks } from "../../hooks/use-fetch-fixed-route-bus-blocks";
import { useFetchFixedRouteBusBlocksByNumber } from "../../hooks/use-fetch-fixed-route-bus-blocks-by-number";

export const FixedRouteContext = React.createContext();

const FixedRoute = ({setApiErrors}) => {
  const fetchFixedRouteBusBlocks = useFetchFixedRouteBusBlocks();
  const fetchFixedRouteBusBlocksByNumber = useFetchFixedRouteBusBlocksByNumber();

  return (
    <div>
      <section className="container">
        <Table
          TableContext={FixedRouteContext}
          fetchBusBlocks={fetchFixedRouteBusBlocks}
          fetchBusBlocksByNumber={fetchFixedRouteBusBlocksByNumber}
          setApiErrors={setApiErrors}
        />
      </section>
    </div>
  );
};

FixedRoute.propTypes = {
  setApiErrors: PropTypes.func,
};

export default FixedRoute;
